/* @flow */

// Reducers needed for main application

import { combineReducers } from 'redux';

import commonReducers from "./reducers-common";

/* admin */
import admin from "platopulse/admin/admin";

/* setup */
import * as setup from "platopulse/setup/reducers";

/* user settings */
import * as user from "platopulse/user/reducers";

/* dashboards */
import dashboards from "platopulse/dashboards/dashboards";
import dashboard from "platopulse/dashboard/dashboard";
import * as home from "platopulse/home/reducers";

/* questions / query builder */
import new_query from "platopulse/new_query/new_query";
import questions from "platopulse/questions/questions";
import labels from "platopulse/questions/labels";
import collections from "platopulse/questions/collections";
import * as qb from "platopulse/query_builder/reducers";

/* data reference */
import reference from "platopulse/reference/reference";

/* alerts */
import alert from "platopulse/alert/alert";

/* pulses */
import * as pulse from "platopulse/pulse/reducers";

/* xrays */
import xray from "platopulse/xray/xray";


export default {
    ...commonReducers,

    // main app reducers
    alert,
    dashboards,
    dashboard,
    home: combineReducers(home),
    new_query,
    pulse: combineReducers(pulse),
    qb: combineReducers(qb),
    questions,
    collections,
    labels,
    reference,
    xray,
    setup: combineReducers(setup),
    user: combineReducers(user),
    admin,
};



// WEBPACK FOOTER //
// ./reducers-main.js